import { JSONStorage } from './json';

export class CachedJSONStorage<T = unknown> extends JSONStorage<T> {
  #cache: T | null = null;

  getItem(): Readonly<T> | null {
    if (!this.#cache) {
      this.#cache = super.getItem();
    }
    return this.#cache;
  }

  setItem(value: T) {
    this.#cache = value;
    this.#sync();
  }

  #sync() {
    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      requestIdleCallback(() => super.setItem(this.#cache as T));
    } else {
      setTimeout(() => super.setItem(this.#cache as T), 0);
    }
  }
}
